/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAppointmentTransferInput } from "../../entities/models/AppointmentTransferInput";
import { z } from "zod/v4";

export const modelsAppointmentTransferInputSchema = z.object({
    "barber_id": z.int(),
"station_id": z.int()
    }) as unknown as z.ZodType<ModelsAppointmentTransferInput>